import { defineStore } from 'pinia'
import { ref } from 'vue'
import { TInvitation } from '../../types'

export const useInvitationStore = defineStore('Invitations', () => {
  const invitations = ref<Array<Partial<TInvitation>>>([])

  const setInvitations = (payload: Array<Partial<TInvitation>>) => {
    invitations.value = payload
  }

  const addInvitation = (payload: TInvitation) => {
    const overrideInvitations = invitations.value
    const index = invitations.value.findIndex(
      (invitation) =>
        new Date(invitation.delivery_date ?? '') >
        new Date(payload.delivery_date ?? ''),
    )

    if (index === -1) {
      overrideInvitations.push(payload)
    } else {
      overrideInvitations.splice(index, 0, payload)
    }

    invitations.value = overrideInvitations
  }

  const deleteInvitation = (payload: TInvitation) => {
    invitations.value = invitations.value.filter(
      (invitation) => invitation.id !== payload.id,
    )
  }

  const updateInvitation = (payload: TInvitation) => {
    const index = invitations.value.findIndex(
      (invitation) => invitation.id === payload.id,
    )

    if (index !== -1) {
      invitations.value[index] = payload
    }
  }

  return {
    invitations,
    setInvitations,
    updateInvitation,
    addInvitation,
    deleteInvitation,
  }
})
